import i18next from "i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import bundledResources from "./i18n-bundled-resources";
import I18NextHttpBackend from "i18next-http-backend";
import I18NextChainedBackend from "i18next-chained-backend";
import I18NextLocalStorageBackend from "i18next-localstorage-backend";

const instance = i18next
  .use(I18NextChainedBackend)
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next);
const version = process.env.NEXT_PUBLIC_BUILD_ID;

instance.init({
  ns: [
    "common",
    "line_sheet_sets",
    "order_sheet_sets",
    "auth",
    "order_confirmation_invoices",
    "proforma_invoices",
    "bank_remittance_receipts",
    "deposit_invoices",
    "credit_invoices",
    "landing",
    "countries",
    "dashboard",
    "my_dash",
    "error_page",
    "order_history",
    "settlement",
    "path_pick",
    "membership",
    "path_pick_guide",
    "path_pick_landing",
  ],
  fallbackLng: "en",
  // 지원 언어를 고정하고 지역 코드는 떼어 쓴다. 없으면 브라우저 언어가 en-US·ko-KR 일 때
  // /locales/en-US/*.json 처럼 없는 파일을 namespace 수만큼 요청하는데, 정적 호스팅이
  // index.html 로 폴백해 200 HTML 이 돌아오므로 전부 파싱 실패한다(Googlebot 도 en-US 다).
  supportedLngs: ["en", "ko", "it"],
  load: "languageOnly",
  // 랜딩용 common·landing 은 번들에서 바로 쓰고 나머지만 backend 로 받는다.
  // 이유는 i18n-bundled-resources.js 참고.
  resources: bundledResources,
  partialBundledLanguages: true,
  // htmlTag 는 order 에서 뺀다. _document.tsx 가 <html lang="ko"> 를 정적으로 박기 때문에
  // (크롤러용) 그대로 두면 lang 속성이 언어 감지 입력이 되어 영어권 사용자가 한국어로 넘어간다.
  // 나머지 order 와 caches 는 i18next-browser-languagedetector 기본값과 동일하다.
  detection: {
    order: [
      "querystring",
      "cookie",
      "localStorage",
      "sessionStorage",
      "navigator",
    ],
    caches: ["localStorage"],
  },
  backend: {
    backends: [I18NextLocalStorageBackend, I18NextHttpBackend],
    backendOptions: [
      {
        defaultVersion: "1793781718",
      },
      {
        loadPath: "/locales/{{lng}}/{{ns}}.json?v=" + version,
      },
    ],
  },
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
});
